var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h24v24H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "scale(.02083)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "b",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABD0lEQVRoge2ZsQ7CMAxEPaD+cjfIRpj4Fwa+iJYfYGGCILVSFHWIyt2lIJ90a87PlqNUNXO5aOqST8lj8gvkITlOZ9MVgYWXjgoAZOdL3xUAeeCWz5SGOUDrsJ8HiJnpknaLIQdoLQeoVDDSUisAQpYBh2AD7JKvRU5ABigm8HlWX4os2CRUO0CDUN5CFAj1NQqHqAHowd4nPwy02DUArC+20qsmsSWAAwsggn1OfhbZYU3xtQBILS3xqs7Pan2NflW8mQ6AUryZBoBWvBkf4C8ec70ROj9LtQPBwJ2fpb5G4XKA1nKABeVPZ7oYANKpOoDoTGmYFGAoApG+KQCYv1mPCoBugkBOQvqj2+Wq0Bsj1ZJ3q9aqbAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.c1cb14383c702da988566aa4d7da1fa6.svg";
export { ForwardRef as ReactComponent };